import React, { useEffect, useState } from 'react'
import { SearchIcon } from '@chakra-ui/icons';
import { Box, Flex, Text, Stack, Tabs, Button, TabList, TabPanels, Tab, TabPanel, AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Avatar, Badge, IconButton, Input, InputGroup, InputLeftElement, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Skeleton, SkeletonCircle, Switch, Table, TableCaption, TableContainer, Tbody, Td, Tfoot, Th, Thead, Tr, useColorModeValue, useDisclosure, useToast, BreadcrumbItem, BreadcrumbLink, Breadcrumb, Tooltip, FormControl, FormLabel, SimpleGrid, Card, CardBody, Image, Heading, Portal, Popover, PopoverTrigger, PopoverContent, PopoverArrow, PopoverBody, InputRightElement, CloseButton } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStateContext } from '../../../../context/ContextProvider';
import axiosClient from '../../../../axios-client';
import { TbListDetails } from 'react-icons/tb';
import MyPagination from '../../../../components/MyPagination';
import { RiFileExcel2Fill } from 'react-icons/ri';
import { FaRegEye } from 'react-icons/fa6';
import { AsyncPaginate } from 'react-select-async-paginate';
import { DateRange } from 'react-date-range';
import format from 'date-fns/format';
import fr from 'date-fns/locale/fr';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { GrPowerReset } from 'react-icons/gr';

let isFirstLoad_GestStock = true;
function GestStock() {
  const { user, setUser, setToken, currentBusiness } = useStateContext()
  const navigate = useNavigate()
  const { t } = useTranslation();
  const toast = useToast()


  const [statusStock, setStatusStock] = useState('')

  const [dataOrder, setDataOrder] = useState([])
  const [loading, setLoading] = useState(false)
  const [paginationData, setPaginationData] = useState()

  const [searchTerm, setSearchTerm] = useState('');
  const [statusSelected, setStatusSelected] = useState('');

  const [dateDebutValue, setDateDebutValue] = useState("");
  const [dateFinValue, setDateFinValue] = useState("");

  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  });

  const handleSelectDateRange = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setSelectionRange(ranges.selection);
    setDateDebutValue(format(startDate, 'yyyy-MM-dd'));
    setDateFinValue(format(endDate, 'yyyy-MM-dd'));
  };

  const clearDateRange = () => {
    setDateDebutValue("");
    setDateFinValue("");
    setSelectionRange({
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    });
  };

  const [selectedProduct, setSelectedProduct] = useState(null);

  const selectTextColor = useColorModeValue('black', 'white');
  const selectBg = useColorModeValue('transparent', 'transparent');
  const selectMenuBg = useColorModeValue('white', '#2D3748');
  const selectBorderColor = useColorModeValue('#E2E8F0', 'rgba(255, 255, 255, 0.16)');
  const selectHoverBg = useColorModeValue('#EDF2F7', '#4A5568');

  const loadProductOptions = async (search, loadedOptions, { page }) => {
    try {
      const res = await axiosClient.get(`/products/get_All_Products_names/?client=${user?.id}&page_size=20&page=${page}&search_term=${search}&userRole=${user?.role}&business=${currentBusiness?.id}`, { hideLoader: true });
      const results = res.data.results || [];
      const hasMore = res.data.next !== null && res.data.next !== undefined;
      return {
        options: results.map(product => ({ value: product.id, label: product.title })),
        hasMore,
        additional: { page: page + 1 },
      };
    } catch (error) {
      // // console.error('Error fetching products', error);
      return { options: [], hasMore: false };
    }
  };

  // PAGINATION

  const [currentPage, setCurrentPage] = useState(0);

  ////////////////////////////////the size of the table//////////////////////////////
  const PAGE_SIZE = 10;
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setCurrentPage(0);
  };

  const fetchData = (pageSize, currentPage, searchTerm, statusSelected, dateDebutValue, dateFinValue, productSelected) => {
    try {
      setLoading(true)
      axiosClient.get(`/commandes/getStockOrder/?clientId=${user.id}&page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}&statusSelected=${statusSelected}&dateDebut=${dateDebutValue}&dateFin=${dateFinValue}&product=${productSelected ? productSelected.value : ''}&business=${currentBusiness?.id}`, { hideLoader: !isFirstLoad_GestStock }).then((res) => {
            isFirstLoad_GestStock = false;
        // if (user.role === ('AdminClient')) {
        //     setDataOrder(res.data.filter(e => e.client === user.id && e.is_deleted === false && e.assigned_to !== null && e.assigned_to_stock === null && e.assigned_to_suivi === null))
        // }
        // else if (user.role === ('ManagerClient')) {
        //     setDataOrder(res.data.filter(e => e.client === user.works_for && e.is_deleted === false && e.assigned_to !== null && e.assigned_to_stock === null && e.assigned_to_suivi === null))
        // }
        // else {
        //     setDataOrder(res.data.filter(e => e.assigned_to === user.id && e.is_deleted === false))
        // }
        // console.log('RESULTS DATA : ', res.data.results);
        if (res.data.length !== 0) {
          setDataOrder(res.data.results)
          setPaginationData(res.data)
        } else {
          setDataOrder([])
          setPaginationData([])
        }

        if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
          setUser({});
          setToken(null);
          localStorage.removeItem("tokenExpirationTime");
          localStorage.removeItem("refreshTimeAdmin");
          localStorage.removeItem("role");

          // Vérifier si le toast n'est pas déjà affiché
          if (!toast.isActive('accountDisabled')) {
            toast({
              id: 'accountDisabled',
              description: t("le compte est désactivé"),
              status: 'warning',
              variant: 'left-accent',
              duration: 2000,
              isClosable: true,
              position: 'bottom-right'
            });
          }
        }
      })
      setLoading(false)
    } catch (error) {
      // console.log('ERROR : ', error);
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData(pageSize, currentPage, searchTerm, statusSelected, dateDebutValue, dateFinValue, selectedProduct)
  }, [user?.id, currentPage, searchTerm, pageSize, statusSelected, dateDebutValue, dateFinValue, selectedProduct])

  // Update status

  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const cancelRef = React.useRef()
  const [statusId, setStatusId] = useState()

  const onOpenAlert = (id) => {
    setIsAlertOpen(true);
    setStatusId(id)
  };
  const onCloseAlert = () => {
    setIsAlertOpen(false);
    setStatusStock('')
    setStatusId()
  };

  const HandleChangeStatus = async () => {
    try {
      await axiosClient.patch(`commandes/${statusId}/`, {
        status_stock: statusStock
      }).then((res) => {
        setDataOrder(dataOrder.map((item) => {
          if (item.id === res.data.id) {
            return {
              ...item,
              status_stock: res.data.status_stock
            }
          }
          return item
        }))
        onCloseAlert()
        toast({
          description: t(`Statut est changé avec succès`),
          status: 'success',
          duration: 2000,
          isClosable: true,
          variant: 'left-accent',
          position: 'bottom-right'
        })
      })
    } catch (error) {
      // console.log('ERROR : ', error);
    }
  }

  const borderColor = useColorModeValue("gray.300", "gray.600")
  const textSM = useColorModeValue('gray.400', 'gray.500')
  const bgStack = useColorModeValue('white', 'gray.700')

  const resetFilters = () => {
    setSearchTerm('');
    setStatusSelected('');
    clearDateRange();
    setSelectedProduct(null);
    setCurrentPage(0);
  };

  const handleExportExcel = async () => {
    try {
      // Configurer la requête pour recevoir un Blob
      const response = await axiosClient.get(`export-orders/${user?.id}/`, {
        responseType: 'blob',
      });

      if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
        setUser({});
        setToken(null);
        localStorage.removeItem("tokenExpirationTime");
        localStorage.removeItem("refreshTimeAdmin");
        localStorage.removeItem("role");

        // Vérifier si le toast n'est pas déjà affiché
        if (!toast.isActive('accountDisabled')) {
          toast({
            id: 'accountDisabled',
            description: t("le compte est désactivé"),
            status: 'warning',
            variant: 'left-accent',
            duration: 2000,
            isClosable: true,
            position: 'bottom-right'
          });
        }
        return;
      }

      // Créer un objet URL à partir du Blob
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Créer un lien pour télécharger le fichier
      const link = document.createElement('a');
      link.href = url;

      // Nom du fichier
      link.setAttribute('download', 'commandes_en_cours.xlsx'); // Vous pouvez changer le nom du fichier ici
      document.body.appendChild(link);
      link.click();

      // Supprimer le lien une fois le téléchargement terminé
      link.parentNode.removeChild(link);

      toast({
        description: t("Le fichier a été exporté avec succès."),
        variant: 'left-accent',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right'
      });
    } catch (error) {
      // // console.error('Une erreur s\'est produite lors de l\'exportation du fichier!', error);
      toast({
        description: t("Une erreur s'est produite lors de l'exportation du fichier."),
        variant: 'left-accent',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right'
      });
    }
  }

  //vider l'input de date fin
  useEffect(() => {
    if (!dateDebutValue) {
      // Si dateDebutValue est vide, on réinitialise dateFinValue
      setDateFinValue('');
    } else if (dateFinValue && dateDebutValue >= dateFinValue) {
      // Si dateDebutValue est supérieur ou égal à dateFinValue, on réinitialise dateFinValue
      setDateFinValue('');
    }
  }, [dateDebutValue, dateFinValue]);

  // Aperçu Commande
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [productsOrderData, setProductsOrderData] = useState([])
  const previewRef = React.useRef()
  const [previewId, setPreviewId] = useState()
  const [loadingPreview, setLoadingPreview] = useState(true)

  const onOpenPreview = async (id) => {
    setIsPreviewOpen(true);
    setLoadingPreview(true)
    await axiosClient.get(`/produitCommande/getProductsOrder/?commande=${id}&client_id=${user?.id}&userRole=${user?.role}`)
      .then((res) => {
        setProductsOrderData(res.data)

        if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
          setUser({});
          setToken(null);
          localStorage.removeItem("tokenExpirationTime");
          localStorage.removeItem("refreshTimeAdmin");
          localStorage.removeItem("role");

          // Vérifier si le toast n'est pas déjà affiché
          if (!toast.isActive('accountDisabled')) {
            toast({
              id: 'accountDisabled',
              description: t("le compte est désactivé"),
              status: 'warning',
              variant: 'left-accent',
              duration: 2000,
              isClosable: true,
              position: 'bottom-right'
            });
          }
        }
      })
      .catch((error) => {
        // console.log('ERROR : ', error)
        setLoadingPreview(false)
      })
      .finally(() => {
        setLoadingPreview(false)
      })
    setPreviewId(id)
  };
  const onClosePreview = () => {
    setIsPreviewOpen(false);
    setProductsOrderData([])
    setLoadingPreview(true)
    setPreviewId()
  };

  return (
    <Box mt="5px">

      <Flex>
        <Box w="90%" mt={2} mb={5}>
          <Breadcrumb fontFamily='Plus Jakarta Display' fontStyle={"italic"} fontSize={{ base: "20px", sm: "25px", lg: "27px" }} color="gray">
            <BreadcrumbItem>
              <BreadcrumbLink onClick={() => navigate('/')}>{t("Accueil")}</BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbItem isCurrentPage>
              <BreadcrumbLink>{t("Gestion stock")}</BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>
        </Box>
      </Flex>

      <Flex
        px={2}
        py={5}
        mx={5}
        bg={bgStack}
        rounded={"2xl"}
        mt={2}
        align={'center'}
        justify={'center'}

      >

        <Stack
          w={'full'}
          maxW='full'
          rounded={'lg'}
          mt={2}
          px={{ base: 1, md: 5 }}
        >
          {/* Search input */}
          <Flex align="center" gap={3} w="full" direction={{ base: 'column', lg: 'row' }} justify="space-between" mb={6}>
            <Flex gap={3} w="full" direction={{ base: 'column', md: 'row' }} flexWrap="wrap">
              <Flex w={{ base: '100%', md: '300px' }} gap={statusSelected === 'En cours' ? 3 : 0}>
                <Select 
                  borderColor={borderColor} 
                  borderRadius="xl" 
                  size="md" 
                  fontSize={{ base: 13, lg: 16 }} 
                  w={'100%'} 
                  value={statusSelected} 
                  onChange={(e) => {
                    setCurrentPage(0)
                    setStatusSelected(e.target.value)
                  }}
                >
                  <option value=''>{t('Statut de stock')}</option>
                  <option value='Nouveau'>{t('Nouveau')}</option>
                  <option value='Épuisé'>{t('Épuisé')}</option>
                  <option value='Annulé'>{t('Annulé')}</option>
                  <option value='En cours'>{t('En cours')}</option>
                  <option value='Emballé'>{t('Emballé')}</option>
                  <option value='Collecté'>{t('Collecté')}</option>
                </Select>

                {statusSelected === 'En cours' &&
                  <Tooltip label={t('Télécharger le fichier excel')}>
                    <IconButton
                      icon={<RiFileExcel2Fill />}
                      colorScheme='green'
                      variant='outline'
                      onClick={handleExportExcel}
                      rounded="xl"
                      aria-label="Export Excel"
                    />
                  </Tooltip>
                }
              </Flex>

              <Box w={{ base: '100%', md: '200px' }}>
                <AsyncPaginate
                  loadOptions={loadProductOptions}
                  onChange={(option) => {
                    setCurrentPage(0);
                    setSelectedProduct(option);
                  }}
                  value={selectedProduct}
                  isClearable
                  placeholder={t('Filtrer par produit...')}
                  noOptionsMessage={() => t('Aucun produit trouvé')}
                  additional={{ page: 1 }}
                  styles={{
                    control: (p) => ({ ...p, backgroundColor: selectBg, borderColor: selectBorderColor, color: selectTextColor, minHeight: '40px', borderRadius: '12px' }),
                    menu: (p) => ({ ...p, zIndex: 9999, backgroundColor: selectMenuBg, borderRadius: '12px' }),
                    option: (p, s) => ({ ...p, backgroundColor: s.isFocused ? selectHoverBg : 'transparent', color: selectTextColor }),
                    singleValue: (p) => ({ ...p, color: selectTextColor }),
                    input: (p) => ({ ...p, color: selectTextColor }),
                  }}
                />
              </Box>

              <Box w={{ base: '100%', md: '250px' }}>
                <Popover placement="bottom-start">
                  <PopoverTrigger>
                    <InputGroup size="md">
                      <Input
                        readOnly
                        value={dateDebutValue ? `${dateDebutValue} ${t("au")} ${dateFinValue}` : t("Choisir une période")}
                        cursor="pointer"
                        rounded="xl"
                        borderColor={borderColor}
                        bg={useColorModeValue('white', 'gray.700')}
                        _hover={{ borderColor: 'purple.400' }}
                        _focus={{ borderColor: 'purple.500', boxShadow: 'none' }}
                      />
                      {dateDebutValue && (
                        <InputRightElement w="auto" pr={2}>
                          <IconButton
                            variant="ghost"
                            size="sm"
                            icon={<CloseButton size="sm" />}
                            onClick={(e) => {
                              e.stopPropagation();
                              clearDateRange();
                            }}
                            aria-label={t("Effacer la date")}
                          />
                        </InputRightElement>
                      )}
                    </InputGroup>
                  </PopoverTrigger>
                  <Portal>
                    <PopoverContent w="auto" p={0} border="none" shadow="2xl" zIndex={9999}>
                      <PopoverArrow />
                      <PopoverBody p={0}>
                        <DateRange
                          ranges={[selectionRange]}
                          onChange={handleSelectDateRange}
                          locale={fr}
                          maxDate={new Date()}
                          rangeColors={['#805AD5']}
                        />
                      </PopoverBody>
                    </PopoverContent>
                  </Portal>
                </Popover>
              </Box>

              <InputGroup size="md" w={{ base: '100%', md: '200px' }}>
                <InputLeftElement pointerEvents='none'>
                  <SearchIcon color="gray.400" />
                </InputLeftElement>
                <Input
                  borderColor={borderColor}
                  borderRadius="xl"
                  placeholder={t("Recherche...")}
                  value={searchTerm}
                  onChange={(e) => {
                    setCurrentPage(0)
                    setSearchTerm(e.target.value)
                  }}
                  _focus={{ borderColor: 'purple.500', boxShadow: 'none' }}
                />
              </InputGroup>

              <IconButton
                icon={<GrPowerReset />}
                onClick={resetFilters}
                variant="outline"
                colorScheme="purple"
                rounded="xl"
                aria-label={t("Réinitialiser")}
                title={t("Réinitialiser les filtres")}
              />
            </Flex>
          </Flex>

          <TableContainer>
            <Table size={{ base: 'sm', md: 'md' }} variant='simple'>
              <Thead>
                <Tr>
                  <Th borderBottomColor='gray.400'>{t("#ID")}</Th>
                  <Th borderBottomColor='gray.400'>{t("Client")}</Th>
                  <Th borderBottomColor='gray.400'>{t("Adresse")}</Th>
                  <Th borderBottomColor='gray.400'>{t("téléphone")}</Th>
                  <Th borderBottomColor='gray.400'>{t("Status")}</Th>
                  <Th borderBottomColor='gray.400'>{t("Coupons")}</Th>
                  <Th borderBottomColor='gray.400'>{t("Prix")}</Th>
                  <Th borderBottomColor='gray.400'>{t("Date Création")}</Th>
                  <Th borderBottomColor='gray.400'>{t("Date Modification")}</Th>
                  <Th borderBottomColor='gray.400'>{t("Options")}</Th>
                </Tr>
              </Thead>
              <Tbody>

                {loading &&
                  <Tr>
                    <Td><Skeleton h={10} w={10} /></Td>
                    <Td><Skeleton height='20px' /></Td>
                    <Td>
                      <Flex flexDirection={"column"} gap={2}>
                        <Skeleton height='20px' />
                        <Skeleton height='10px' />
                      </Flex>
                    </Td>
                    <Td>
                      <Flex flexDirection={"column"} gap={2}>
                        <Skeleton height='20px' />
                        <Skeleton height='10px' />
                        <Skeleton height='10px' />
                      </Flex>
                    </Td>
                    <Td><Skeleton height='20px' /></Td>
                    <Td><Skeleton height='20px' /></Td>
                    <Td><Skeleton height='20px' /></Td>
                    <Td><Skeleton height='20px' /></Td>
                    <Td><Skeleton height='20px' /></Td>
                  </Tr>
                }
                {
                  dataOrder.length > 0 ?
                    dataOrder.map((val, key) => {
                      return (
                        <Tr key={key}>
                          <Td>{val.code}</Td>
                          <Td>
                            <Flex flexDirection={"column"}>
                              <Text fontWeight='semibold'>{val.full_name}</Text>
                              {val.email !== "undefined" && <Text fontSize='sm' color={textSM}>{val.email}</Text>}
                            </Flex>
                          </Td>
                          <Td>
                            <Flex flexDirection={"column"}>
                              <Text fontSize={'md'}>{val.pays}, {val.ville}</Text>
                              <Text fontSize={'sm'} color={textSM}>{val.address}</Text>
                            </Flex>
                          </Td>
                          <Td>
                            <a href={`https://wa.me/${val.tel}`} target='blank'>
                              {val.tel}
                            </a>
                          </Td>
                          <Td>
                            <Badge colorScheme={
                              val?.status_stock !== 'Collecté'
                                ? (['Épuisé', 'Annulé'].includes(val?.status_stock))
                                  ? 'red'
                                  : ([null, ''].includes(val?.status_stock))
                                    ? 'blue'
                                    : 'orange'
                                : 'green'
                            } rounded="xl" px={2} cursor='pointer' textTransform='uppercase' onClick={() => {
                              {
                                if ((val.status_delivery === '') || (val.status_delivery === null)) {
                                  onOpenAlert(val.id)
                                }
                              }
                            }}>
                              {val?.status_stock ? val?.status_stock : 'Nouveau'}
                            </Badge>
                          </Td>
                          <Td>
                            <Text textAlign='center'>
                              {val.coupon ? val.couponTitle : '-'}
                            </Text>
                          </Td>
                          <Td>
                            <Flex gap={1} alignItems="center">
                              <Text color={val?.coupon && 'gray.400'} fontSize={val?.coupon && 15} fontWeight='semibold' textDecoration={val?.coupon && 'line-through'}>{val?.price}</Text>
                              <Text h={"100%"} fontSize={12} >{currentBusiness?.order_currency}</Text>
                            </Flex>
                            {
                              val?.coupon &&
                              <Flex gap={1} alignItems="center">
                                <Text fontWeight='semibold'>{val?.priceWithCoupon}</Text>
                                <Text h={"100%"} fontSize={12} >{currentBusiness?.order_currency}</Text>
                              </Flex>
                            }
                          </Td>
                          <Td>
                            <Flex flexDirection="column">
                              <Text fontSize="sm" fontWeight="medium">{new Date(val.date_creation).toLocaleDateString()}</Text>
                              <Text fontSize="xs" color="gray.500">{new Date(val.date_creation).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</Text>
                            </Flex>
                          </Td>
                          <Td>
                            {val.date_modification ? (
                              <Flex flexDirection="column">
                                <Text fontSize="sm" fontWeight="medium">{new Date(val.date_modification).toLocaleDateString()}</Text>
                                <Text fontSize="xs" color="gray.500">{new Date(val.date_modification).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</Text>
                              </Flex>
                            ) : (
                              <Text fontSize="sm" color="gray.400">-</Text>
                            )}
                          </Td>
                          <Td>
                            <Flex gap={5}>
                              <Button variant='outline' colorScheme='cyan' leftIcon={<TbListDetails />} onClick={() => navigate('/Detail-Gestion-confirmation', {
                                state: {
                                  id: val.id,
                                  tel: val.tel
                                }
                              })}>
                                {t("Détails")}
                              </Button>
                              <Button variant='outline' colorScheme='green' leftIcon={<FaRegEye />}
                                onClick={() => onOpenPreview(val.id)}>
                                {t("Aperçu")}
                              </Button>
                            </Flex>
                          </Td>
                        </Tr>
                      )
                    })
                    :
                    <Tr>
                      <Td colSpan={6}>
                        <Text fontSize={18}>{t("Donnée introuvable")}</Text>
                      </Td>
                    </Tr>
                }
              </Tbody>
            </Table>
          </TableContainer>

          {/* //////////////////////////////////////////Pagination////////////////////////////////////////// */}
          <Flex flexDirection={{ base: 'column', lg: "row" }} justify="space-between" align="center" w="100%">
            <Box flex="1">
              <MyPagination
                paginationData={paginationData}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                PAGE_SIZE={pageSize}
              />
            </Box>

            <Select rounded={"md"} size={"sm"} w="70px" value={pageSize} onChange={handlePageSizeChange}>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </Select>
          </Flex >
          {/* //////////////////////////////////////////Pagination////////////////////////////////////////// */}

        </Stack >


        {/* Alert to Update confirmation status */}

        < AlertDialog
          isOpen={isAlertOpen}
          leastDestructiveRef={cancelRef}
          onClose={onCloseAlert}
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                {t('Statut de stock')}
              </AlertDialogHeader>

              <AlertDialogBody>
                <Text>
                  {t('Ici, vous pouvez modifier le statut de stock.')}
                </Text>

                <Select
                  mt={3}
                  rounded='lg'
                  size={"sm"}
                  value={statusStock}
                  onChange={e => setStatusStock(e.target.value)}
                >
                  <option value=''>{t('Statut de stock')}</option>
                  <option value='Épuisé'>{t('Épuisé')}</option>
                  <option value='Annulé'>{t('Annulé')}</option>
                  <option value='En cours'>{t('En cours')}</option>
                  <option value='Emballé'>{t('Emballé')}</option>
                  <option value='Collecté'>{t('Collecté')}</option>
                </Select>
              </AlertDialogBody>

              <AlertDialogFooter>
                <Button colorScheme='yellow' size="sm" variant='outline' isDisabled={!statusStock} mr={3} onClick={HandleChangeStatus}>
                  {t('Modifier')}
                </Button>
                <Button onClick={onCloseAlert} size="sm" >{t('Annuler')}</Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      </Flex>


      {/* Preview Order */}
      < Modal closeOnOverlayClick={false} size={"2xl"} isOpen={isPreviewOpen} leastDestructiveRef={cancelRef} onClose={onClosePreview}>
        <ModalOverlay />
        <ModalContent maxHeight={'90%'}>
          <ModalHeader>{t("Aperçu la commande")}</ModalHeader>
          <ModalCloseButton />



          <SimpleGrid px={{ base: 2, md: 10 }} overflowY={'auto'} mb={5} mt={2} templateColumns={{ base: 'repeat(auto-fill,minmax(250px,1fr))', md: 'repeat(auto-fill,minmax(200px,1fr))' }} spacing={7}>
            {loadingPreview
              ? <Skeleton marginTop={5} height='300px' borderRadius={10} />
              : productsOrderData.map((val, key) => {
                return (
                  <Card key={key} mt={5} mb={5} rounded={"xl"} shadow="lg" borderWidth={1} borderColor={'gray.200'}>
                    <CardBody p={0} m={0}>
                      <Stack position={"relative"}>
                        <Image
                          height={"200px"}
                          src={val.produit?.images[0]?.image}
                          alt='Image'
                          objectFit="cover"
                          roundedTop={"xl"}
                        />
                      </Stack>
                      <Stack p={3} alignItems='start' mt={2}>
                        <Heading fontSize={'xl'} fontFamily={'body'} fontWeight={500}>
                          {val.produit?.title}
                        </Heading>
                        {/* <Text lineHeight={5} textAlign={'justify'} color={'descColor'}>
        {val.produit?.description}
    </Text> */}

                        <Flex justifyContent="space-between" w='full'>
                          {val.color && <Flex gap={2}>
                            <Text color='gray'>{t('Couleur')} :</Text>
                            <Text fontWeight='semibold'>{val.color}</Text>
                          </Flex>}
                          {val.size && <Flex gap={2}>
                            <Text color='gray'>{t('Taille')} :</Text>
                            <Flex gap={1}>
                              <Text fontWeight='semibold'>{val.size}</Text>
                            </Flex>
                          </Flex>}
                        </Flex>

                        <Flex justifyContent="space-between" w='full'>
                          <Flex gap={2}>
                            <Text color='gray'>{t('Qté')} :</Text>
                            <Text fontWeight='semibold'>{val.quantity}</Text>
                          </Flex>
                          <Flex gap={2}>
                            <Text color='gray'>{t('Prix')} :</Text>
                            <Flex gap={1}>
                              <Text fontWeight='semibold'>{val.price}</Text>
                              <Text fontWeight='gray' fontSize={13}></Text>
                            </Flex>
                          </Flex>
                        </Flex>

                      </Stack>
                    </CardBody>
                  </Card>
                )
              })}

          </SimpleGrid>

        </ModalContent>
      </Modal >

    </Box>
  )
}

export default GestStock